import { Button, IconButton } from "@mui/material";
import { hover } from "framer-motion";
import React from "react";

interface ZaloProps {}

const Zalo: React.FC<ZaloProps> = (props) => {
  const handleZaloClick = () => {
    window.open("https://zalo.me/0965152818", "_blank");
  };
  return (
    <IconButton
      aria-label="zalo"
      size="large"
      className="!fixed !bottom-7 !p-2 !right-7 md:bottom-14 md:right-14 z-50 w-12 h-12 !bg-primary_blue/30 text-white rounded-full shadow-lg hover:!bg-primary_blue !transition-all !duration-300 !transform hover:!scale-110 focus:!outline-none focus:!ring-2 md:focus:ring-4 focus:!ring-blue-400 focus:!ring-opacity-50 !flex !items-center !justify-center"
      onClick={handleZaloClick}
    >
      <img
        src="/images/zalo.png"
        alt="Zalo"
        className="object-contain w-11 h-11"
      />
    </IconButton>
  );
};

export default Zalo;
